var map = {
	"./3DS.png": 46554,
	"./Amiga.png": 51882,
	"./DC.png": 32837,
	"./DS.png": 95787,
	"./FDS.png": 29398,
	"./GB.png": 2874,
	"./GBA.png": 81889,
	"./GBC.png": 81772,
	"./GCN.png": 94386,
	"./GEN.png": 82230,
	"./N64.png": 98968,
	"./NES.png": 61539,
	"./PC-98.png": 93523,
	"./PC.png": 634,
	"./PS1.png": 55789,
	"./PS2.png": 97696,
	"./PS3.png": 56658,
	"./PS4.png": 31937,
	"./SCD.png": 5307,
	"./SNES.png": 6268,
	"./SS.png": 51961,
	"./Switch.png": 14246,
	"./Wii.png": 68829,
	"./WiiU.png": 188
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99686;